module.exports = __webpack_public_path__ + "static/media/buyNowCalculator.f92b72d6.svg";